import React from "react";

const Contact = () => {
  return (
    <section class="contact section" id="contact">
      <h2 class="section-title">Contact</h2>

      <div class="contact-container bd-grid">
        <div class="contact-info">
          <h3 class="contact-subtitle">EMAIL</h3>
          <span class="contact-text">manishhansalmeh@gmail.com</span>

          <h3 class="contact-subtitle">Address</h3>
          <span class="contact-text">Bihar, India</span>
        </div>
        <form
          class="contact-form"
          action="https://getform.io/f/e3cb1d40-670e-4936-9b66-2b2718df70c3"
          method="POST"
        >
          <div class="contact-inputs">
            <input
              type="text"
              name="name"
              placeholder="Name"
              required=""
              class="contact-input"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              required=""
              class="contact-input"
            />
          </div>
          <textarea
            name="message"
            placeholder="Message here"
            cols="0"
            rows="10"
            required=""
            class="contact-input"
          ></textarea>
          <button type="submit" class="contact-button">
            Send
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
